<app-client-info></app-client-info>

<app-table (parentFunc)="table1rowFunc($event)"  [sizeOptions]="sizeOptions"  [Title]="unusableTitle" [Collection]="unusableCollection" [displayedColumns]="displayedColumns"></app-table>
